/**
 * AlertHistoryTabContent Component
 *
 * Content for the Alert History tab in the dashboard.
 * Displays resolved/dismissed alerts with empty state handling.
 */

import { AlertCircleIcon } from '@shopify/polaris-icons';
import { TabEmptyState } from './TabEmptyState';
import { AlertHistoryTable } from './AlertHistoryTable';
import type { EnhancedAlert } from '../../types/dashboard';

/**
 * Props for AlertHistoryTabContent component
 */
export interface AlertHistoryTabContentProps {
  /** Filtered alert history to display */
  filteredHistory: EnhancedAlert[];
  /** Current search query */
  searchQuery: string;
  /** Whether the shop has test data */
  hasTestData?: boolean;
}

/**
 * Tab content component for the Alert History tab
 */
export function AlertHistoryTabContent({
  filteredHistory,
  searchQuery,
  hasTestData,
}: AlertHistoryTabContentProps) {
  if (filteredHistory.length === 0) {
    return (
      <div className="empty-state-section">
        <TabEmptyState
          icon={searchQuery ? AlertCircleIcon : undefined}
          illustration={searchQuery ? undefined : 'no-alert-history'}
          title={
            searchQuery
              ? `No history matches "${searchQuery}"`
              : 'No alert history yet'
          }
          description="Once alerts are resolved or dismissed, they'll appear here for reference"
        />
      </div>
    );
  }

  return (
    <AlertHistoryTable
      alerts={filteredHistory}
      hasTestData={hasTestData}
    />
  );
}
